import React from 'react'
import { Icon } from 'antd'
import { IconProps } from 'antd/lib/icon'

export default (props: IconProps & { css?: React.CSSProperties }) => (
  <Icon {...props} />
)
